import { apiClient, ApiClient } from "@/lib/api/api-client";
import { District, Province, Ward } from "@/modules/types/metadata/metadata";
import { BaseResponse } from "@/modules/types/response";

export interface ProvinceResponse extends BaseResponse {
  provinces: Province[];
}

export interface DistrictResponse extends BaseResponse {
  districts: District[];
}

export interface WardResponse extends BaseResponse {
  wards: Ward[];
}

export class LocationService {
  private BASE_PATH =
    process.env.API_MAPDATA_ENDPOINT || "http://localhost:8003/map";
  private apiClient: ApiClient = apiClient;
  private apiVersion = "v1.0.0";
  constructor(apiVersion?: string) {
    this.apiVersion = apiVersion || this.apiVersion;
  }

  async getProvinces(keyword?: string): Promise<ProvinceResponse> {
    return await this.apiClient.fetch<ProvinceResponse>(
      `${this.BASE_PATH}/${this.apiVersion}/provinces?${keyword ? `keyword=${keyword}` : ""}`,
      {
        cache: "force-cache",
      },
    );
  }

  async getDistricts(
    provinceCode: string,
    keyword?: string,
  ): Promise<DistrictResponse> {
    return await this.apiClient.fetch<DistrictResponse>(
      `${this.BASE_PATH}/${this.apiVersion}/districts?provinceCode=${provinceCode}&${keyword ? `keyword=${keyword}` : ""}`,
      {
        cache: "force-cache",
      },
    );
  }

  async getWards(
    districtCode: string,
    keyword?: string,
  ): Promise<WardResponse> {
    return await this.apiClient.fetch<WardResponse>(
      `${this.BASE_PATH}/${this.apiVersion}/wards?districtCode=${districtCode}&${keyword ? `keyword=${keyword}` : ""}`,
      {
        cache: "force-cache",
      },
    );
  }
}

export const locationService = new LocationService();
